<div class="o-block c-card border-radius-0 p-xs-card text-left d-flex align-items-center" [hidden]="disabled">
  <button>
    <i *ngIf="imageSource" class="c-icon c-icon--{{imageSource}} u-icon--big"></i>
    <span class="text-light-gray pl-3">{{label}}</span>
  </button>
</div>
